import { BehaviorSubject } from "rxjs";

export class RefreshSubject extends BehaviorSubject<null> {
  constructor() {
    super(null);
  }

  next() {
    super.next(null)
  }
}